var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"mt-6",attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"6"}},[_c('CrearEditarUsuario')],1),_c('v-col',{staticClass:"mt-6",attrs:{"cols":"6"}},[_c('EventosUsuario')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }